import { useQuery } from '@tanstack/react-query';
import { fetchTenants, TenantListParams } from '@/services/platform-admin-api';

export const PLATFORM_TENANTS_KEY = ['platform', 'tenants'];

export function usePlatformTenants(params: TenantListParams = {}) {
  return useQuery({
    queryKey: [...PLATFORM_TENANTS_KEY, params],
    queryFn: () => fetchTenants(params),
    staleTime: 30_000,
  });
}
